<template>
	<div
		class="hero-modal-ad-container"
		:style="!isOpen ? 'display:none !important;' : ''"
		@click.self="closeModal"
	>
		<div class="hero-modal-ad">
			<button
				type="button"
				class="hero-modal-close"
				aria-label="Close modal"
				@click="closeModal"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="40"
					viewBox="0 -960 960 960"
					width="40"
					fill="#0d0d12"
				>
					<path
						d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
					/>
				</svg>
			</button>

			<!-- Success State -->
			<Transition name="fade">
				<div
					v-if="showValidationSuccess"
					class="modal-success-state"
				>
					<div class="modal-success-icon">
						<svg
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M5 13l4 4L19 7"
							/>
						</svg>
					</div>
					<h2 class="text-2xl font-bold text-slate-900 text-center">You're In!</h2>
					<p class="text-base text-slate-500 text-center">
						You have successfully registered. Redirecting you now...
					</p>
				</div>
			</Transition>

			<!-- Form State -->
			<div
				v-show="!showValidationSuccess"
				class="flex flex-col gap-4"
			>
				<div class="flex flex-col gap-2">
					<h2 class="text-3xl text-medium text-center text-black">
						The Game is Rigged
					</h2>
					<h3 class="text-xl text-black text-center">
						But Our AI-driven analysis Has Leveled the Playing Field
					</h3>
				</div>
				<p class="text-base text-slate-400 text-center">
					Sign up for access to institutional grade tools and insights – and join
					10,000+ traders
				</p>

				<form
					class="modal-form optin_form"
					method="GET"
				>
					<input
						v-model="name"
						name="name"
						type="text"
						placeholder="Name"
						class="form-input text-black"
						required
					/>

					<input
						name="first_name"
						type="hidden"
						:value="first_name"
					/>
					<input
						name="last_name"
						type="hidden"
						:value="last_name"
					/>

					<div class="flex flex-col lg:flex-row gap-3 w-full">
						<div class="relative w-full">
							<input
								:id="formLeadId"
								name="email"
								type="email"
								placeholder="Your email address"
								:class="[
									'form-input text-black',
									showValidationError &&
									validationErrors.email &&
									validationErrors.email !== 'valid'
										? 'border-red-500'
										: ''
								]"
								required
							/>
							<div
								class="error_email text-xs text-red-700 pb-5 text-start !text-xs"
								:style="{
									display:
										showValidationError &&
										validationErrors.email &&
										validationErrors.email !== 'valid'
											? 'block'
											: 'none'
								}"
							>
								Enter a valid email address.
							</div>
						</div>

						<div class="relative w-full">
							<input
								name="phone"
								type="tel"
								placeholder="Phone"
								:class="[
									'form-input text-black',
									showValidationError &&
									validationErrors.phone &&
									validationErrors.phone !== 'valid'
										? 'border-red-500'
										: ''
								]"
								required
							/>
							<div
								class="error_phone text-xs text-red-700 pb-5 text-start !text-xs"
								:style="{
									display:
										showValidationError &&
										validationErrors.phone &&
										validationErrors.phone !== 'valid'
											? 'block'
											: 'none'
								}"
							>
								{{
									validationErrors.phone_error ||
									validationErrors.phone ||
									"Enter a valid phone number."
								}}
							</div>
						</div>
					</div>

					<input
						type="hidden"
						name="funnel_id"
						:value="funnel_id"
					/>
					<input
						type="hidden"
						name="page_id"
						:value="page_id"
					/>

					<div class="checkbox-container">
						<input
							id="modal-offers"
							name="offers"
							type="checkbox"
							class="form-checkbox"
							required
						/>
						<label
							for="modal-offers"
							class="text-xs text-slate-400"
						>
							<strong>I AGREE TO RECEIVE MARKETING</strong>
							By entering your info and clicking I AGREE below, you provide your
							electronic signature, express written consent and binding agreement to
							our
							<a
								href="/terms-service-use-agreement/"
								target="_blank"
								class="hover:text-underline text-blue-300 text-xs font-semibold underline"
							>
								Terms of Use
							</a>
							,
							<a
								href="/privacy-policy"
								target="_blank"
								class="hover:text-underline text-blue-300 text-xs font-semibold underline"
							>
								Privacy Policy
							</a>
							and for
							<a
								href="http://stockstotrade.com/"
								target="_blank"
								class="hover:text-underline text-blue-300 text-xs font-semibold underline"
							>
								StocksToTrade.Com Inc.
							</a>
							and its affiliates
							<a
								href="/disclosure-of-related-and-partner-entities/"
								target="_blank"
								class="hover:text-underline text-blue-300 text-xs font-semibold underline"
							>
								Millionaire Publishing LLC, and Millionaire Media LLC
							</a>
							, along with its agents and assigns, to email, call and text you at the
							email address and telephone number you provided above (or later),
							including possibly using an automatic telephone dialing system,
							prerecorded messages and artificial/A.I. voices, with financial education
							content, training invitations, market insights, and promotional offers
							related to trading education programs, including outside calling times of
							8am to 9pm local time and even if you are on a DNC list. Frequency of
							text messages may vary; reply STOP to opt-out. Normal rates apply and
							consent is not a condition of purchase as you can always receive info by
							calling us directly. This website may record your interactions with it
							and future calls may be recorded/monitored.
						</label>
					</div>

					<button
						class="information-subscribe-button text-uppercase"
						@click="handleSubmit"
					>
						I agree, Submit
					</button>
				</form>
			</div>
		</div>
		<div
			class="hero-modal-overlay"
			@click="closeModal"
		></div>
	</div>
</template>

<script setup>
import { store } from "@/utils/store";
const props = defineProps({
	isOpen: {
		type: Boolean,
		default: false
	},
	showValidationSuccess: {
		type: Boolean,
		default: false
	},
	showValidationError: {
		type: Boolean,
		default: false
	},
	validationErrors: {
		type: Object,
		default: () => ({})
	}
});

// Name splitting logic
const name = ref("");
const first_name = ref("");
const last_name = ref("");

// Watch for changes in the name field and split it
watch(name, (newName) => {
	if (!newName || newName.trim() === "") {
		first_name.value = "";
		last_name.value = "";
		return;
	}

	// Split the name by spaces and filter out empty strings
	const nameParts = newName
		.trim()
		.split(/\s+/)
		.filter((part) => part.length > 0);

	if (nameParts.length === 0) {
		first_name.value = "";
		last_name.value = "";
	} else if (nameParts.length === 1) {
		// Only one word: it's the first name
		first_name.value = nameParts[0];
		last_name.value = "";
	} else if (nameParts.length === 2) {
		// Two words: first word is first name, second is last name
		first_name.value = nameParts[0];
		last_name.value = nameParts[1];
	} else {
		// Three or more words: first two words are first name, rest are last name
		first_name.value = nameParts.slice(0, 2).join(" ");
		last_name.value = nameParts.slice(2).join(" ");
	}
});

const closeModal = () => {
	store.toggleLeadCaptureModal();
};

const handleSubmit = () => {
	// Form submission is handled by the marketing script
	// This function can be used for additional custom logic if needed
};
// Close modal on escape key and prevent body scroll
onMounted(() => {
	const handleEscape = (e) => {
		if (e.key === "Escape" && props.isOpen) {
			closeModal();
		}
	};
	window.addEventListener("keydown", handleEscape);
	onBeforeUnmount(() => {
		window.removeEventListener("keydown", handleEscape);
	});
});

// Prevent body scroll when modal is open
watch(
	() => props.isOpen,
	(newValue) => {
		if (import.meta.client) {
			if (newValue) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		}
	}
);

// Close modal when validation succeeds
watch(
	() => props.showValidationSuccess,
	(newValue) => {
		if (newValue) {
			// Wait a brief moment to show the success message, then close
			setTimeout(() => {
				closeModal();
			}, 1500); // 1.5 seconds delay to let user see the success message
		}
	}
);

// Core Data - matching PHP configuration
const funnel_id = "stt_blog"; // Funnel ID for this page
const page_id = "stt-homepage-optin";

const formLeadId = computed(() => {
	return `inf_field_Email-stt-homepage-optin`;
	// return `inf_field_Email-${props.id}`;
});
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.hero-modal-close {
	cursor: pointer;
	margin-bottom: 16px;
	margin-left: auto !important;
	display: block;
	max-width: 24px;
	width: 24px;
	height: 24px;
	position: relative;
	text-align: right;
	background: transparent;
	border: none;
	padding: 0;
	outline: none;
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;

	@include breakpoint(lg) {
		margin-bottom: 24px;
	}

	&:focus {
		outline: none;
	}

	&:hover {
		opacity: 0.7;
	}

	svg {
		display: block;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
}

.hero-modal-overlay {
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	z-index: 0;
}

.hero-modal-ad {
	min-width: 320px;
	min-height: 200px;
	max-width: 578px;
	padding: 20px 24px 64px;
	overflow: hidden;
	border-radius: 12px;
	background-color: white;
	position: relative;
	z-index: 1;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;

	// Reset all button styles within modal
	button {
		font-family: inherit;
		line-height: inherit;
		color: inherit;
		margin: 0;
		text-transform: none;
		-webkit-font-smoothing: inherit;
		-moz-osx-font-smoothing: inherit;
	}

	@include breakpoint(lg) {
		border: none;
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
		padding: 20px 32px 40px;
	}
	&::before {
		content: "";
		background-color: #1e3a8a;
		height: 24px;
		width: 100%;
		display: block;
		left: 0;
		right: 0;
		bottom: 0;
		position: absolute;
	}

	.mb-5 {
		margin-bottom: 32px;
	}

	img {
		width: 100%;
		border-radius: 12px;
	}
}

.modal-title {
	text-align: center;
	font-size: 20px;
	margin-bottom: 12px;
	font-weight: 700;
	@include breakpoint(lg) {
		font-size: 28px;
		margin-bottom: 16px;
	}
}

.modal-subtitle {
	text-align: center;
	font-size: 18px;
	margin-bottom: 12px;
	font-weight: 600;
	color: $slate-900;
	@include breakpoint(lg) {
		font-size: 20px;
		margin-bottom: 16px;
	}
}

.modal-description {
	text-align: center;
	font-size: 14px;
	margin-bottom: 24px;
	color: $slate-700;
	@include breakpoint(lg) {
		font-size: 16px;
		margin-bottom: 32px;
	}
}

.hero-modal-ad-container {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	z-index: 999;
	display: flex;
	padding: 64px 16px;
	background-color: rgba($color: #fff, $alpha: 0.65);
	overflow: auto;

	.information-subscribe-button {
		padding-top: 12px;
		padding-bottom: 12px;
		font-size: 18px;
		width: 100%;
		background: $yellow-300;
		color: $slate-900;
		border-radius: 12px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.2s;
		margin-top: 24px;

		&:hover {
			background: $yellow-400;
		}
	}
}

.modal-content {
	max-height: 600px;
	overflow-y: auto;
}

.modal-form {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.form-input {
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	font-size: 14px;
	transition: border-color 0.2s;

	&:focus {
		outline: none;
		border-color: $blue-300;
	}

	&::placeholder {
		color: #94a3b8;
	}

	&.border-red-500 {
		border-color: #ef4444;

		&:focus {
			border-color: #dc2626;
		}
	}
}

.checkbox-container {
	display: flex;
	gap: 12px;
	align-items: start;
}

.disclaimer-text {
	margin-top: 8px;
	margin-bottom: 16px;
	line-height: 1.5;
	color: #94a3b8;
}

.form-checkbox {
	margin-top: 4px;
	min-width: 18px;
	height: 18px;
	cursor: pointer;
}

.checkbox-label {
	font-size: 11px;
	color: $slate-700;
	line-height: 1.4;
	cursor: pointer;

	@include breakpoint(lg) {
		font-size: 12px;
	}

	strong {
		font-weight: 700;
		color: $slate-900;
	}

	.link {
		color: $blue-500;
		text-decoration: underline;

		&:hover {
			color: $blue-700;
		}
	}
}

.modal-success-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	padding: 48px 24px;
	min-height: 200px;
}

.modal-success-icon {
	width: 72px;
	height: 72px;
	border-radius: 50%;
	background-color: #01b885;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;

	svg {
		width: 40px;
		height: 40px;
		color: white;
	}
}

.fade-enter-active {
	transition: opacity 0.3s ease;
}

.fade-leave-active {
	transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.gradient-text {
	background: linear-gradient(110.32deg, #091d56 8.05%, #331290 77.58%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}
</style>
